<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
    <table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Ativo</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="onus in onusFormat" :key="onus.id">
          <td data-label="Tipo do Ônus:">
            <span>{{ onus.nome }}</span>
          </td>
          <td data-label="Ônus ativo:">
            <span v-if="onus.ativo == true">Sim</span>
            <span v-else>Não</span>
          </td>
          <td class='coluna-acoes'>
            <div class="coluna-acoes-tabela">
              <!-- Visualizar -->
              <div class="icone-tabela">
                <router-link :to="{
                  name: 'OnusShow',
                  params: { id: onus.id },
                }">
                  <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar" />
                </router-link>
              </div>
              <!-- Editar -->
              <div class="icone-tabela">
                <router-link :to="{
                  name: 'OnusEdit',
                  params: { id: onus.id },
                }">
                  <img src="../../assets/imagens/icon-edit.svg" alt="Editar" title="Editar" />
                </router-link>
              </div>
              <!-- Excluir -->
              <span class="icone-tabela" type="button" @click="opcoesExcluir(onus.id)">
                <img src="../../assets/imagens/icon-delete-preto.svg" alt="Excluir" title="Excluir" />
              </span>
            </div>
          </td>
          <div class="modal-exclusao" :id="onus.id">
            <div class="modal-mask">
              <div class="modal-container">
                <div class="modal-header">
                  <h2>Deseja mesmo excluir esse Ônus?</h2>
                </div>
                <div class="modal-body">
                  <p>Dados do Ônus:</p>
                  <div class="dados">
                    <div class="texto-centralizado">
                      Nome: <span>{{ onus.nome }}</span>
                    </div>
                    <div class="texto-centralizado">
                      <div v-if="onus.ativo == true">
                        Ativo: <span>Sim</span>
                      </div>
                      <div v-else>
                        Ativo: <span>Não</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn-confirmar-exclusao" @click="excluirLinha(onus.id)">Sim</button>
                  <button class="btn-cancelar-exclusao" @click="opcoesExcluir(onus.id)">Não</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        <tr v-if="!onuses || onuses == 0" class="sem-resultados">
          <p><b>Nenhum Resultado Encontrado</b></p>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { parseISO, format } from "date-fns"
  import MsgErroFormularios from "../MsgErroFormularios";
  import OnusApi from "../../services/OnusApi";

  export default {
    name: "TabelaResultadosOnus",
    props: {
      onuses: Array,
      onus: Object,
    },
    components: {
      MsgErroFormularios,
    },
    created() {
      this.onusApi = new OnusApi();
    },
    data() {
      return {
        msgErros: {
          onus: '',
        },
        erro: false,
        onusFormat: this.onuses.map((v) => {
          return {
            ...v,
          };
        }),
      };
    },
    methods: {
      opcoesExcluir(onusId) {
        let modalExclusao = document.getElementsByClassName('modal-exclusao')

        for (let i = 0; i < modalExclusao.length; i++) {
          if (modalExclusao[i].id == onusId) {
            if (modalExclusao[i].style.visibility !== "visible") {
              modalExclusao[i].style.visibility = "visible"
            } else {
              modalExclusao[i].style.visibility = "hidden"
            }
          }
        }
      },
      async excluirLinha(onusId) {
        this.opcoesExcluir(onusId)

        try {
          this.carregando = true;
          this.erro = false;

          if (this.onusApi.cancelTokens.destroyOnus) {
            this.onusApi.cancelTokens.destroyOnus.cancel();
          }

          await this.onusApi.destroyOnus(onusId);
          window.location.reload();
          
        } catch (err) {
          if (this.onusApi.isCancel(err)) {
            return;
          }

          this.carregando = false;
          this.erro = true;

          this.msgErros.onus = "Não foi possível excluir este ônus, pois ele está vinculado a uma cessão/disposição."
        }
      },
      formatarData: function (value) {
        if (value == null) {
          return;
        }
        return format(parseISO(value), "dd/MM/yyyy");
      },
      formatarDataParaComparacao(value) {
        let newValue = new Date(value);
        let timeToCompare = newValue.getTime();
        return timeToCompare;
      }
    },
  };
</script>

<style lang="scss" scoped>
</style>